var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleLeftDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91414 22.5304C6.20703 22.8232 6.6819 22.8232 6.9748 22.5304L11.4192 18.0859C11.6337 17.8714 11.6979 17.5488 11.5818 17.2686C11.4657 16.9883 11.1923 16.8056 10.8889 16.8056H7.19447V9.7778C7.19447 8.35106 8.35106 7.19447 9.7778 7.19447H16.8056V10.8889C16.8056 11.1923 16.9883 11.4657 17.2686 11.5818C17.5488 11.6979 17.8714 11.6337 18.0859 11.4192L22.5304 6.9748C22.8232 6.6819 22.8232 6.20703 22.5304 5.91414L18.0859 1.46969C17.8714 1.25519 17.5488 1.19103 17.2686 1.30711C16.9883 1.4232 16.8056 1.69668 16.8056 2.00002V5.69447H9.7778C7.52264 5.69447 5.69447 7.52264 5.69447 9.7778V16.8056H2.00002C1.69668 16.8056 1.4232 16.9883 1.30711 17.2686C1.19103 17.5488 1.25519 17.8714 1.46969 18.0859L5.91414 22.5304Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleLeftDown);
export default __webpack_public_path__ + "static/media/corner-double-left-down.2384201554d252876952f86c0f3bce39.svg";
export { ForwardRef as ReactComponent };